/* global $, API */

import formatPrice from '../helpers/formatPrice';

const $cart = $('.js-cart');
const $total = $('.js-cart-total');
const $tax = $('.js-cart-tax');
const $subTotal = $('.js-cart-subtotal');
const $shippingCosts = $('.js-shipping-costs');

const ROW_SELECTOR = '.js-cart-item';
const ROW_TOTAL_SELECTOR = '.js-cart-item-total';
const ROW_QUANTITY_SELECTOR = '.js-cart-item-quantity';
const ROW_DELETE_SELECTOR = '.js-cart-item-delete';

const COUPON_WRAPPER = '.js-coupon';

export default {
  initialize() {
    if ($cart.length) {
      this.createListeners();
      this.getItems = () => { this.items = $(ROW_SELECTOR).toArray(); };
      this.getItems();
      this.recalculateTotals();
    }
  },

  createListeners() {
    $cart.on('change', ROW_QUANTITY_SELECTOR, this.handleQuantityChange.bind(this));
    $cart.on('click', ROW_DELETE_SELECTOR, this.handleItemDelete.bind(this));

    $cart.on('recalculate', () => {
      this.recalculateTotals();
    });
  },

  handleQuantityChange(e) {
    const $input = $(e.currentTarget);
    const $row = this.getCartRow($input);
    const quantity = parseInt($input.val(), 10);
    const cartItemId = this.getCartItemId(this.retrieveCartItem($input));

    if (Number.isNaN(quantity)) {
      return;
    }

    this.recalculateRow($row);
    this.recalculateTotals();
    this.updateCartItem(cartItemId, quantity);
  },

  handleItemDelete(e) {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const $cartItem = this.retrieveCartItem($button);
    const cartItemId = this.getCartItemId($cartItem);
    const quantity = this.getQuantityForRow($cartItem);

    this.gtmRemove($cartItem.data('gtm-array'), quantity);

    this.deleteCartItem(cartItemId)
      .then(() => {
        $cartItem.slideUp(500, () => {
          $cartItem.remove();
          $cart.trigger('recalculate');
        });
      });
  },

  /**
   * @param {object} $el
   * @returns {object}
   */
  retrieveCartItem($el) {
    return $el.parents('.js-cart-item');
  },

  /**
   * @param {object} $row
   * @returns {int}
   */
  getCartItemId($row) {
    return parseInt($row.data('id'), 10);
  },

  /**
   * Retrieve the parent cart row for given element
   * @param {Object} $el jQuery element
   * @return {Object} Cart row
   */
  getCartRow($el) {
    return $el.parents(ROW_SELECTOR);
  },

  /**
   * Get price per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getPriceForRow($row, fallback = 0) {
    const val = parseFloat($row.data('price'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get tax per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getTaxForRow($row, fallback = 0) {
    const val = parseFloat($row.data('tax'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get price without tax per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getPriceWithoutTaxForRow($row, fallback = 0) {
    const val = parseFloat($row.data('price-without-tax'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get quantity of the product row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getQuantityForRow($row, fallback = 1) {
    const val = parseInt($row.find(ROW_QUANTITY_SELECTOR).val(), 10);
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Recalculate the total of the product row
   * @param {Object} $row jQuery element of the product row
   * @return {void}
   */
  recalculateRow($row) {
    const price = this.getPriceForRow($row);
    const tax = this.getTaxForRow($row);
    const quantity = this.getQuantityForRow($row);
    const total = price * quantity;
    const totalTax = tax * quantity;
    const prevQuantity = parseInt($row.data('quantity'), 10);

    $row.data('quantity', quantity);

    if (typeof $row.data('gtm-array') !== 'undefined') {
      const diffQuantity = quantity - prevQuantity;

      if (diffQuantity > 0) {
        this.gtmAdd($row.data('gtm-array'), diffQuantity);
      } else if (diffQuantity < 0) {
        this.gtmRemove($row.data('gtm-array'), Math.abs(diffQuantity));
      }

      $row.data('quantity', quantity);
    }

    this.outputRowTotal($row, total);
    this.outputRowTax($row, totalTax);
  },

  /**
   * Output the total price for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total price
   * @return {void}
   */
  outputRowTotal($row, total) {
    $row
      .data('total', total)
      .find(ROW_TOTAL_SELECTOR)
      .html(formatPrice(total));
  },

  /**
   * Output the total tax for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total price
   * @return {void}
   */
  outputRowTax($row, total) {
    $row.data('total-tax', total);
  },

  /**
   * Calculate the cart total and output
   * @return {void}
   */
  recalculateTotals() {
    this.getItems();

    let total = this.items.reduce((acc, item) => (
      acc + parseFloat($(item).data('total'))
    ), 0);

    const tax = 0;

    const couponValue = parseFloat($cart.find(COUPON_WRAPPER).data('value')) * -1;

    const ensurePositive = val => (val < 0 ? 0 : val);

    const subTotal = total - tax;

    if (subTotal <= $shippingCosts.data('free-shipping-costs-from')) {
      total += $shippingCosts.data('shipping-costs');
    }

    $subTotal.html(formatPrice(ensurePositive(subTotal)));
    $shippingCosts.html(formatPrice(ensurePositive($shippingCosts.data('shipping-costs'))));
    $total.html(formatPrice(ensurePositive(total - couponValue)));
    $tax.html(formatPrice(tax));

    $(document).trigger('cart:change', total);
  },

  /**
   * @param {int} cartItemId
   * @param {int} quantity
   * @returns {Promise}
   */
  updateCartItem(cartItemId, quantity) {
    return $.post(API.cartItemUpdate.replace(':id', cartItemId), {
      _method: 'PUT',
      quantity,
    });
  },

  /**
   * @param {int} cartItemId
   * @returns {Promise}
   */
  deleteCartItem(cartItemId) {
    return $.post(API.cartItemDestroy.replace(':id', cartItemId), {
      _method: 'DELETE',
    });
  },

  gtmAdd(productItemObj, quantityDelta) {
    productItemObj.quantity = quantityDelta;

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'addToCart',
        currency: 'EUR',
        value: (productItemObj.price * productItemObj.quantity).toFixed(2),
        items: [
          productItemObj,
        ],
      });
    }
  },

  gtmRemove(productItemObj, quantityDelta) {
    productItemObj.quantity = quantityDelta;

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'removeFromCart',
        currency: 'EUR',
        value: (productItemObj.price * productItemObj.quantity).toFixed(2),
        items: [
          productItemObj,
        ],
      });
    }
  },
};
